// extracted by mini-css-extract-plugin
module.exports = {"AnonMenu":"AnonMenu-module_AnonMenu_2R77M","login":"AnonMenu-module_login_2UqRX","fadeOut":"AnonMenu-module_fadeOut_3jT2I","register":"AnonMenu-module_register_2GP48"};